module.exports = __webpack_public_path__ + "static/media/1.0602f2e5.svg";